export default __webpack_public_path__ + "static/media/christmas-club.5c2abffe.png";